import { useStore } from 'effector-react'
import { $socialMedia, socialMediaMounted, getSocialMediaGroup } from './model'
import { useEffect } from 'react'

export const useEditSocialMedia = () => {
  const socialMedia = useStore($socialMedia)

  const loading = useStore(getSocialMediaGroup.pending)

  useEffect(() => {
    socialMediaMounted()
  }, [])

  return {
    socialMedia,
    loading,
  }
}
